import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import MaskedInput from 'react-text-mask';
import Input from '@mui/material/Input';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import './styles.css';

const TextMaskCustom = React.forwardRef((props, ref) => {
  const { ...other } = props;

  return (
    <MaskedInput
      {...other}
      mask={[/\d/, /\d/, ':', /[0-6]/, /\d/]}
      placeholder="hh:mm"
      showMask
    />
  );
});

TextMaskCustom.displayName = 'TextMaskCustom';

export function stringifyDuration(duration) {
  if (!duration) return null;
  const { hours, minutes } = duration;
  let result = '';
  if (hours < 10) {
    result += 0;
  }
  result = `${result}${hours}:`;
  if (minutes < 10) {
    result += 0;
  }
  result += minutes;
  return result;
}

const DurationInput = React.forwardRef((props, ref) => {
  const {
    value,
    inputId,
    inputName,
    disabled,
    handleChange: updateDuration,
  } = props;

  const [durationValue, setDurationValue] = useState('');

  useEffect(() => { setDurationValue(stringifyDuration(value)); }, [value]);

  const durationOptions = [
    { title: '15', value: '00:15' },
    { title: '30', value: '00:30' },
    { title: '60', value: '01:00' },
    { title: '120', value: '02:00' },
  ];

  const handleChange = (event) => {
    setDurationValue(event.target.value);
    updateDuration(event.target.value);
  };

  return (
    <>
      <Box>
        <ToggleButtonGroup
          id={`${inputId}_buttons`}
          value={durationValue}
          onBlur={() => updateDuration(durationValue)}
          onChange={handleChange}
          disabled={disabled}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          {durationOptions.map((option) => (
            <ToggleButton
              key={option.value}
              value={option.value}
              sx={{
                borderRadius: '4px !important',
                '&:hover': {
                  bgcolor: '#4F83CC',
                  color: 'white',
                },
                '&.Mui-selected': {
                  bgcolor: '#4F83CC',
                  color: 'white',
                  '&:hover': {
                    bgcolor: '#4F83CC',
                    color: 'white',
                  },
                },
              }}
            >
              {option.title}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>
      <br />
      <Box>
        <Input
          value={durationValue}
          onBlur={() => updateDuration(durationValue)}
          onChange={handleChange}
          inputProps={{ id: inputId, name: inputName, ref }}
          inputComponent={TextMaskCustom}
          disabled={disabled}
          disableUnderline
        />
      </Box>
    </>
  );
});

DurationInput.displayName = 'DurationInput';
export default DurationInput;
